import { render, staticRenderFns } from "./EditTagProducts.vue?vue&type=template&id=6d3f400f&"
import script from "./EditTagProducts.vue?vue&type=script&lang=js&"
export * from "./EditTagProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports